<template>
  <div class="uk-grid uk-child-width-1-1" data-uk-grid>
    <div>
      <div class="uk-flex uk-flex-between uk-flex-middle">
        <div>
          <h1 class="uk-h4 uk-margin-remove">
            <span data-uk-icon="icon:image; ratio:1.2"></span>
            Banner
          </h1>
        </div>
        <div>
          <a @click.prevent="$router.go(-1)" class="uk-button uk-button-small uk-button-secondary">
            <span class="uk-margin-small-right uk-icon" uk-icon="icon: arrow-left"></span>
            Zurück
          </a>
        </div>
      </div>
    </div>
    <div>
      <div class="uk-card uk-card-small uk-card-default uk-box-shadow-small uk-margin-bottom">
        <div class="uk-card-body">
          <div
            class="uk-grid"
            data-uk-grid
            uk-sortable="handle: .uk-sortable-handle;"
            v-if="banners.length"
          >
            <div class="uk-width-1-3@m" v-for="banner in banners" :key="banner.id">
              <div class="uk-card uk-card-default" style="box-shadow: none;background: #e5e5e5">
                <div class="uk-card-media-top">
                  <img :src="`${baseUrl}/${banner.path}`" class="uk-height-max-small" />
                </div>
                <div class="uk-card-body">
                  <div class="uk-flex uk-flex-middle uk-flex-between">
                    <button
                      class="uk-icon-button uk-text-danger uk-icon"
                      uk-icon="trash"
                      uk-tooltip="Banner löschen"
                      @click.prevent="remove(banner.id)"
                    ></button>
                    <!--
                    <div>
                      <span class="uk-sortable-handle">::</span>
                    </div>
                    -->
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="uk-grid" data-uk-grid>
            <div class="uk-width-1-1">
              <upload
                :url="uploadUrl"
                :multiple="true"
                name="banner"
                :id="1"
                type="banner"
                @uploaded="bannerAdded"
              ></upload>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Upload from '@/components/Upload'
import { mapActions, mapGetters } from 'vuex'
import BannerService from '@/services/banner.service'
import Configuration from '@/configuration';
const baseUrl = Configuration.value('apiUrl')
const uploadUrl = `${Configuration.value('apiBackend')}/banner/upload`



import 'izitoast/dist/css/iziToast.min.css'
import iziToast from 'izitoast/dist/js/iziToast.min.js'

export default {
  components: {
    Upload
  },
  data() {
    return {
      uploadUrl: uploadUrl,
      baseUrl: baseUrl
    }
  },
  mounted() {
    this.getBanners()
  },
  computed: {
    ...mapGetters(['banners'])
  },
  methods: {
    ...mapActions(['getBanners']),
    bannerAdded() {
      this.getBanners()
    },
    remove(id) {
      const $this = this
      this.$uikit.modal
        .confirm('Banner löschen?', {
          labels: {
            cancel: 'Abbrechen',
            ok: 'Löschen'
          }
        })
        .then(
          function() {
            BannerService.remove(id).then(() => {
              iziToast.success({
                title: 'OK',
                message: 'Banner gelöscht',
                timeout: 5000,
                position: 'topCenter'
              })
              $this.getBanners()
            })
          },
          function() {
            console.log('Rejected.')
          }
        )
    }
  }
}
</script>
